import React from 'react'

function Course() {
  return (
    <div>
       {/* <!-- Start Hero --> */}
    <section class="common-page-hero">
        <img src="assets/img/service/c13.png" class="common-hero-bg ak-bg" alt="..." />
        <div class="common-hero-content">
            <div class="common-hero-info">
                <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
                    <p class="ak-section-subtitle animation-title"> Courses</p>
                    <h2 class="ak-section-title animation-title" style={{fontSize:'45px'}}>
                    SEMANTIC Skills Junction: Bridging Talent and Technology
                    </h2>
                </div>
                <p class="back-btn"><a href="/">Home</a> / Course</p>
            </div>
            <a href="" class="phone-number">(+91) 7619617023</a>
        </div>
    </section>
    {/* <!-- End Hero --> */}

    {/* <!-- Start All Services--> */}
    <div class="ak-height-60 ak-height-lg-50"></div>
    <h2 class="ak-section-title animation-title" style={{fontSize:'33px',textAlign:'center'}}>
                   <b>COURSES</b> 
                    </h2>
                    
    <div class="container" style={{marginTop:'20px'}}>
    
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-5">
            <a href="/manufacturing" class="service-card style-two">
                <div class="service-thumb">
                    <img src="./assets/img/service/s1.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/s1.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title">WAFER FAB FINISHING SCHOOL PROGRAMME</p>
                    <p class="service-desp" style={{textAlign:'justify'}}>
                        This service involves creating customized financial plans tailored to the individual needs and goals of clients. Financial planning may.
                    </p>
                </div>
                <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div>
            </a>
            <a href="/osat" class="service-card style-two">
                <div class="service-thumb">
                    <img src="./assets/img/service/s2.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/s2.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title" >OSAT & ATMP FINISHING SCHOOL PROGRAMME</p>
                    <p class="service-desp" style={{textAlign:'justify'}}>
                        This service involves creating customized financial plans tailored to the individual needs and goals of clients. Financial planning may.
                    </p>
                </div>
                <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div>
            </a>
            <a href="/feb" class="service-card style-two">
                <div class="service-thumb">
                    <img src="./assets/img/service/s3.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/s3.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title" style={{textAlign:'justify'}}>INTEGRATED WAFER FAB OSAT FINISHING SCHOOL</p>
                    <p class="service-desp" style={{textAlign:'justify'}}>
                        This service involves creating customized financial plans tailored to the individual needs and goals of clients. Financial planning may.
                    </p>
                </div>
                <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div>
            </a>
            <a href="/nurturing" class="service-card style-two">
                <div class="service-thumb">
                    <img src="./assets/img/service/s4.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/s4.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title">NURTURING WAFER FAB, OSAT NEW HIRES</p>
                    <p class="service-desp" style={{textAlign:'justify'}}>
                        This service involves creating customized financial plans tailored to the individual needs and goals of clients. Financial planning may.
                    </p>
                </div>
                <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div>
            </a>
            <a href="/Design" class="service-card style-two mb-10">
                <div class="service-thumb">
                    <img src="./assets/img/service/s51.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/s51.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title"> Digital IC Design</p>
                    <p class="service-desp" style={{textAlign:'justify'}}>
                        This service involves creating customized financial plans tailored to the individual needs and goals of clients. Financial planning may.
                    </p>
                </div>
                <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div>
            </a>
            <a href="/Design" class="service-card style-two">
                <div class="service-thumb">
                    <img src="./assets/img/service/s61.png" alt="..." />
                    <div class="overlay-image">
                        <img src="./assets/img/service/s61.png" alt="..." />
                    </div>
                </div>
                <div class="service-info">
                    <p class="service-title"> Analog IC Design</p>
                    <p class="service-desp" style={{textAlign:'justify'}}>
                        This service involves creating customized financial plans tailored to the individual needs and goals of clients. Financial planning may.
                    </p>
                </div>
                <div class="service-footer">
                    <p class="more-btn">
                        <span> View More </span>
                        <span class="svg-icon style-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                    fill="#030917"
                  />
                  <path
                    d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
                    </p>
                </div>
            </a>
        </div>
    </div>
    <span class="ak-scrollup">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z"
          fill="currentColor"
        />
      </svg>
    </span>
    {/* <!-- End All Services--> */}
    </div>
  )
}

export default Course
